import { useRouter } from 'next/router'
import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { useSetAtom } from 'jotai'
import { RootState } from '@mindfulchefuk/types/store'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { setDeliveryDate } from '@mindfulchefuk/actions/basketActions'
import { isBefore } from 'date-fns'
import routesConfig from '@mindfulchefuk/config/routesConfig'
import { addNotification } from '@mindfulchefuk/features/Notifications/notificationsSlice'
import { useEffect } from 'react'
import { useAvailableDates } from '@mindfulchefuk/features/Operations/hooks/useAvailableDates'
import { flagChooseRecipesOnboardingRefactor } from '@mindfulchefuk/flagsAndExperiments'
import { deliveryDateAtom } from '@mindfulchefuk/store/onboarding'

type TUseResetInvalidDeliveryDate = {
  isCheckoutFlow?: boolean
}

export const useResetInvalidDeliveryDate = async ({
  isCheckoutFlow,
}: TUseResetInvalidDeliveryDate): Promise<void> => {
  const isChooseRecipesRefactorEnabled = useFeatureIsOn(
    flagChooseRecipesOnboardingRefactor
  )
  const dispatch = useDispatch()
  const router = useRouter()
  const setJotaiDeliveryDate = useSetAtom(deliveryDateAtom)

  const {
    recipes: { firstAvailableDeliveryDate, unavailableDates },
  } = useAvailableDates()

  const selectedDeliveryDate = useSelector(
    (store: RootState) => store.basket.selectedDeliveryDate,
    shallowEqual
  )

  const isSelectedDateUnavailable =
    unavailableDates.includes(selectedDeliveryDate) ||
    isBefore(selectedDeliveryDate, firstAvailableDeliveryDate)

  useEffect(() => {
    const handleSelectedDateUnavailable = async () => {
      if (isChooseRecipesRefactorEnabled) {
        setJotaiDeliveryDate(firstAvailableDeliveryDate)
      } else {
        dispatch(setDeliveryDate(firstAvailableDeliveryDate))
      }

      if (isCheckoutFlow) {
        await router.replace(
          routesConfig.chooseRecipes.pathname,
          routesConfig.chooseRecipes.as
        )

        dispatch(addNotification({ id: 'error-date-reset' }))
      }
    }

    if (isSelectedDateUnavailable) {
      handleSelectedDateUnavailable()
    }
  }, [
    dispatch,
    isCheckoutFlow,
    isSelectedDateUnavailable,
    firstAvailableDeliveryDate,
    router,
    isChooseRecipesRefactorEnabled,
    setJotaiDeliveryDate,
  ])
}
